import { S } from './app_state.js?v=20260817c';
import { cloneSystemData } from '../../plugin-contracts/system_data_contract.mjs';
import { normalizeProjectLevels } from '../project/project_level_constants.js';
import { getProjectModelRevision } from '../project/project_revision_service.js';

const projectTokens = new WeakMap();
const dragTokens = new WeakMap();
function freeze(value) {
  if (value && typeof value === 'object') {
    Object.values(value).forEach(freeze);
    Object.freeze(value);
  }
  return value;
}
function tokenFor(cache, object, data = {}) {
  if (!object || typeof object !== 'object') return null;
  if (!cache.has(object)) cache.set(object, Object.freeze(data));
  return cache.get(object);
}

/** Identities are opaque; the environment contains only shared room geometry. */
export function createSystemContextPorts(isDisposed) {
  let environmentCache = null;
  return Object.freeze({
    current() {
      if (isDisposed()) return null;
      return Object.freeze({ projectToken: tokenFor(projectTokens, S.project),
        sheetId: S.drawingSheets?.activeSheetId ?? null,
        view: S.project?.currentView, revision: getProjectModelRevision() });
    },
    environment() {
      if (isDisposed()) return null;
      const project = S.project;
      const revision = getProjectModelRevision();
      if (!environmentCache || environmentCache.project !== project || environmentCache.revision !== revision) {
        environmentCache = { project, revision, value: freeze({
          levels: cloneSystemData(normalizeProjectLevels(project?.levels)),
          sketchWalls: cloneSystemData(project?.sketchWalls || {})
        }) };
      }
      return environmentCache.value;
    }
  });
}

export function readSystemInteractionContext() {
  const drag = S.drag;
  if (drag && dragTokens.get(drag)?.type !== drag.type) dragTokens.delete(drag);
  return Object.freeze({ active: Boolean(drag?.active), type: drag?.type ?? null,
    token: tokenFor(dragTokens, drag, { type: drag?.type ?? null }) });
}

/** Reused by owner normalizers; never includes another product's payload. */
export function readProjectEnvironment(project) {
  return freeze({ levels: cloneSystemData(normalizeProjectLevels(project?.levels)),
    sketchWalls: cloneSystemData(project?.sketchWalls || {}) });
}
